import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dreamy%20anime%20style%20cherry%20blossom%20landscape%20with%20ancient%20Japanese%20temple%20gate%20surrounded%20by%20countless%20blooming%20sakura%20trees%2C%20soft%20morning%20light%20filtering%20through%20petals%2C%20floating%20cherry%20petals%20dancing%20in%20gentle%20breeze%2C%20shallow%20stream%20reflecting%20pink%20canopy%2C%20magical%20ethereal%20atmosphere%2C%20pastel%20color%20palette%2C%20illustration%20style%20with%20dreamy%20soft%20focus%2C%20clean%20composition&width=1920&height=1080&seq=sakura-hero-bg&orientation=landscape"
        alt="樱境物语 - 唯美樱花世界"
        title="樱境物语 - 樱花主题沉浸式叙事体验"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>

      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
        <p className="text-primary-200 text-sm md:text-base tracking-widest mb-4 font-label animate-[fadeInUp_0.8s_ease-out]">
          沉浸式樱花叙事体验
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-6 animate-[fadeInUp_0.8s_ease-out_0.15s]">
          {heroData.title}
        </h1>
        <p className="text-xl md:text-3xl font-heading text-primary-200 mb-4 animate-[fadeInUp_0.8s_ease-out_0.3s]">
          {heroData.subtitle}
        </p>
        <p className="text-sm md:text-base text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed animate-[fadeInUp_0.8s_ease-out_0.45s]">
          {heroData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_0.8s_ease-out_0.6s]">
          <a
            href="#download"
            className="px-8 py-3.5 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            {heroData.ctaPrimary}
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <Link
            to="/category/story"
            className="px-8 py-3.5 text-sm font-medium rounded-full border border-background-200/50 text-background-50 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {heroData.ctaSecondary}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-200/70 text-2xl"></i>
      </div>
    </section>
  );
}